import React from "react";

//Images
import regular1 from "../../../images/variations/stones-regular.jpg";
import regular2 from "../../../images/variations/stones-regular-diagram.jpg";
import permeable1 from "../../../images/variations/stones-permeable.jpg";
import permeable2 from "../../../images/variations/stones-permeable-diagram.jpg";

const Stones = () => {
  return (
    <div className="row justify-content-center panel-stones">
      <div className="col-12 text-uppercase text-center mb-5">
        <h3 className="text-blue">Types of Stones</h3>
      </div>
      <div className="col-12 col-md-6 col-xl-5 text-center">
        <img src={regular1} alt="Regular Stone" />
        <h4 className="text-uppercase mt-3">Regular</h4>
        <div className="description">
          <p>
            Because regular pavers are set in sand above a compacted class-2
            base material, they are not ideal for draining water.
          </p>
        </div>
        <img src={regular2} alt="Regular Stone Diagram" />
        <h4 className="text-uppercase mt-3">Diagram of regular pavers</h4>
      </div>
      <div className="col-12 col-md-6 col-xl-5 text-center mt-5 mt-lg-0">
        <img src={permeable1} alt="Permeable Stone" />
        <h4 className="text-uppercase mt-3">Permeable</h4>
        <div className="description">
          <p>
          Permeable pavers have wider joints and are set in multiple porous layers of gravel and rock, making it easy for water to pass through and drain into an underground reservoir.
          </p>
        </div>
        <img src={permeable2} alt="Permeable Stone Diagram" />
        <h4 className="text-uppercase mt-3">Diagram of permeable pavers</h4>
      </div>
    </div>
  );
};

export default Stones;
